// extracted by mini-css-extract-plugin
export default {"versionInput":"versionInput___S7LQf","FInputFSingleLine":"FInputFSingleLine___Z0Dyf","error":"error___Xfc04","noEdit":"noEdit___T_S0C"};